import { cn } from "@/lib/cn";

type TextFieldProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> & {
  label: string;
  size?: "sm" | "md";
};

/** 라벨 + 인풋. size="sm" 은 폼 그리드(컴팩트)용. */
export function TextField({ label, size = "md", className, ...rest }: TextFieldProps) {
  const compact = size === "sm";
  return (
    <label className={cn("flex flex-col", compact ? "gap-1" : "gap-1.5")}>
      <span className={compact ? "text-xs text-muted" : "text-sm font-medium text-ink"}>
        {label}
      </span>
      <input
        className={cn(
          "rounded-[10px] border text-ink outline-none transition-colors focus:border-primary",
          compact ? "px-3 py-2 text-sm" : "px-3.5 py-2.5 text-[15px]",
          className
        )}
        style={{ borderColor: "var(--line)", background: "var(--surface-2)" }}
        {...rest}
      />
    </label>
  );
}
